export type ProductDescription =
  | "shopify"
  | "ecommerce"
  | "software"
  | "digital"
  | "membership"
  | "courses"
  | "professional"
  | "events"
  | "retail";

export type AnnualRevenue =
  | "0-500k"
  | "500k-2m"
  | "2m-5m"
  | "5m-10m"
  | "10m-50m"
  | "50m+";

export const formatShopNameToSubdomain = (shopName: string): string => {
  return shopName
    .toLowerCase()
    .replace(/[^\d\sa-z-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};
